import React from 'react';
import { instantiateMap } from '../../services/mapService';
import { getAllPoems } from '../../services/poemService';
import { addMarkersToMap } from '../../services/routeService';
import bg1 from '../../assets/images/b2.png';
import PoemModal from '../../components/PoemModal';


export default class PoemsMap extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            lng: -3.2038,
            lat: 55.9415,
            zoom: 11
        };
        this.mapContainer = React.createRef();
    }

    closeModal = () => {
        this.setState({ openModal: false, showPoemModal: false });
    }

    componentDidMount() {

        document.addEventListener("poem-modal", (message) => {
            console.log(message.detail);
            if (message.detail) {
                this.setState({ showModal: false });
                setTimeout(() => {
                    this.setState({ showPoemModal: true, selectedMarker: message.detail });
                }, 100);
            }
        });

        const map = instantiateMap(this.state, this.mapContainer.current);

        map.on('load', () => {
            addMarkersToMap(map, getAllPoems());
        })

        map.on('move', () => {
            this.setState({
                lng: map.getCenter().lng.toFixed(4),
                lat: map.getCenter().lat.toFixed(4),
                zoom: map.getZoom().toFixed(2)
            });

        });
    }
    render() {
        return (
            <div>
                <div className="pageHeader" style={{ backgroundImage: `url(${bg1})` }}>
                    <h1>Poem Map</h1>
                </div>
                <div ref={this.mapContainer} className="map-container" />
                {this.state.showPoemModal && <PoemModal closeModal={this.closeModal} poem={this.state.selectedMarker}/>}

            </div>
        );
    }
}
